"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var polished_1 = require("polished");

var React = __importStar(require("react"));

var styled_components_1 = __importStar(require("../Themes/styled-components"));

exports.Td = styled_components_1.default('td')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: ", " ", ";\n  height: ", ";\n  font-size: ", ";\n  font-family: ", ";\n  text-align: left;\n  ", ";\n\n  .sportnetui-btn {\n    padding: 0 ", ";\n    font-size: ", ";\n    min-height: ", ";\n    .icon {\n      height: ", ";\n      width: ", ";\n    }\n  }\n"], ["\n  padding: ", " ", ";\n  height: ", ";\n  font-size: ", ";\n  font-family: ", ";\n  text-align: left;\n  ", ";\n\n  .sportnetui-btn {\n    padding: 0 ", ";\n    font-size: ", ";\n    min-height: ", ";\n    .icon {\n      height: ", ";\n      width: ", ";\n    }\n  }\n"])), polished_1.rem(4), polished_1.rem(13), function (_a) {
  var theme = _a.theme;
  return "" + polished_1.rem(theme.table.cellHeight);
}, polished_1.rem(14), function (_a) {
  var theme = _a.theme;
  return theme.fontFamily;
}, function (props) {
  if (props.center) {
    return "text-align: center;";
  }

  if (props.right) {
    return "text-align: right;";
  }

  return "";
}, polished_1.rem(10), polished_1.rem(12), polished_1.rem(26), polished_1.rem(12), polished_1.rem(12));
exports.Th = styled_components_1.default('th')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: ", " ", ";\n  height: ", ";\n  font-size: ", ";\n  text-align: left;\n  ", "\n  ", ";\n  font-weight: bold;\n  color: ", ";\n"], ["\n  padding: ", " ", ";\n  height: ", ";\n  font-size: ", ";\n  text-align: left;\n  ", "\n  ", ";\n  font-weight: bold;\n  color: ", ";\n"])), polished_1.rem(4), polished_1.rem(13), function (_a) {
  var theme = _a.theme;
  return "" + polished_1.rem(theme.table.cellHeight);
}, polished_1.rem(14), function (props) {
  if (props.width) {
    return "width: " + polished_1.rem(props.width);
  }

  return "";
}, function (props) {
  if (props.center) {
    return "text-align: center;";
  }

  if (props.right) {
    return "text-align: right;";
  }

  return "";
}, function (_a) {
  var theme = _a.theme;
  return theme.color.base;
});
exports.Tr = styled_components_1.default('tr')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), function (props) {
  if (props.onClick) {
    return styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        &:hover > td {\n          cursor: pointer;\n          background: ", ";\n        }\n      "], ["\n        &:hover > td {\n          cursor: pointer;\n          background: ", ";\n        }\n      "])), function (_a) {
      var theme = _a.theme;
      return theme.table.hover;
    });
  }

  return "";
});
exports.Tbody = styled_components_1.default('tbody')(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), function (props) {
  if (!props.strip) {
    return styled_components_1.css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n        & > :nth-child(odd) {\n          background-color: ", ";\n          color: ", ";\n        }\n        & > :nth-child(even) {\n          background-color: ", ";\n          color: ", ";\n        }\n      "], ["\n        & > :nth-child(odd) {\n          background-color: ", ";\n          color: ", ";\n        }\n        & > :nth-child(even) {\n          background-color: ", ";\n          color: ", ";\n        }\n      "])), function (_a) {
      var theme = _a.theme;
      return theme.table.oddRowBg;
    }, function (_a) {
      var theme = _a.theme;
      return theme.table.oddRow;
    }, function (_a) {
      var theme = _a.theme;
      return theme.table.evenRowBg;
    }, function (_a) {
      var theme = _a.theme;
      return theme.table.evenRow;
    });
  }

  return "";
});
exports.Thead = styled_components_1.default.thead(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  ", " {\n    background-color: ", ";\n  }\n"], ["\n  ", " {\n    background-color: ", ";\n  }\n"])), exports.Tr, function (_a) {
  var theme = _a.theme;
  return theme.table.headerBg;
});
var TableWrapper = styled_components_1.default.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  overflow-x: scroll;\n  width: 100%;\n"], ["\n  overflow-x: scroll;\n  width: 100%;\n"])));
var TableComponent = styled_components_1.default('table')(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  width: 100%;\n  font-family: ", ";\n  border-collapse: collapse;\n\n  ", ";\n"], ["\n  width: 100%;\n  font-family: ", ";\n  border-collapse: collapse;\n\n  ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.fontFamily;
}, function (props) {
  if (props.mergeRow) {
    return styled_components_1.css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n        ", " {\n          border-bottom: ", " solid ", ";\n          border-top: ", " solid ", ";\n        }\n\n        ", " {\n          border-bottom: ", " solid ", ";\n          border-top: ", " solid ", ";\n        }\n      "], ["\n        ", " {\n          border-bottom: ", " solid ", ";\n          border-top: ", " solid ", ";\n        }\n\n        ", " {\n          border-bottom: ", " solid ", ";\n          border-top: ", " solid ", ";\n        }\n      "])), exports.Tr, polished_1.rem(1), function (_a) {
      var theme = _a.theme;
      return theme.separatorColor;
    }, polished_1.rem(1), function (_a) {
      var theme = _a.theme;
      return theme.separatorColor;
    }, exports.Tr, polished_1.rem(1), function (_a) {
      var theme = _a.theme;
      return theme.separatorColor;
    }, polished_1.rem(1), function (_a) {
      var theme = _a.theme;
      return theme.separatorColor;
    });
  }

  return styled_components_1.css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n      ", " {\n        border: ", " solid ", ";\n      }\n\n      ", " {\n        border: ", " solid ", ";\n      }\n    "], ["\n      ", " {\n        border: ", " solid ", ";\n      }\n\n      ", " {\n        border: ", " solid ", ";\n      }\n    "])), exports.Td, polished_1.rem(1), function (_a) {
    var theme = _a.theme;
    return theme.separatorColor;
  }, exports.Th, polished_1.rem(1), function (_a) {
    var theme = _a.theme;
    return theme.separatorColor;
  });
});

exports.Table = function (props) {
  return React.createElement(TableWrapper, null, React.createElement(TableComponent, {
    mergeRow: props.mergeRow || false
  }, props.children));
};

exports.default = {
  Table: exports.Table,
  Tbody: exports.Tbody,
  Thead: exports.Thead,
  Tr: exports.Tr,
  Th: exports.Th,
  Td: exports.Td
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;